export default __webpack_public_path__ + "static/media/mobileWef.6ce6c5b3.png";